import styled from 'styled-components';

export const MainBadgeContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-right: 25px;
`;

export const TitleContainer = styled.div`
  z-index: 1;
  margin-right: 68px;
  top: 0;
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;

  background: #ec97b9;
  border: 1px solid #282828;
  box-sizing: border-box;
  border-radius: 100px;
  color: #282828;
  padding: 6px 8px;
`;

export const IndexContainer = styled.div`
  z-index: 0;
  position: absolute;
  right: 0;
  top: 0;
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  background: #ec97b9;
  border: 1px solid #282828;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  color: #282828;
  padding: 6px 12px 6px 40px;
`;
